<template>
  <section class="invoice-preview-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <h2>{{ $t("reception.patient-lobby-list") }}</h2>
          </b-col>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="6" cols="12">
            <!-- <h4>Patient Name</h4> -->
            <b-form-group
              :label="$t('reception.patient-name')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="patientName"
                :placeholder="$t('reception.patient-name')"
                @keydown.enter="getPatientCards()"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <h4></h4> -->
            <b-button
              class="mt-50"
              variant="primary"
              @click="getPatientCards()"
            >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" />
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table
              v-if="!loading"
              :items="patientCardsData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              class="position-relative"
              show-empty
              empty-text="No matching patients found"
            >
              <template #cell(patient.phone)="data">
                <p
                  class="mx-2"
                  style="width: 100px"
                  :style="{
                    direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
                  }"
                >
                  {{ getPatientPhone(data) }}
                </p>
              </template>
              <template #cell(patient_card_prescriptions)="data">
                <table class="w-100">
                  <tbody>
                    <tr
                      v-for="item in data.item.patient_card_prescriptions"
                      :key="item.id"
                      class="border-bottom"
                    >
                      <td class="py-1">
                        <div class="prescription-grid">
                          <span class="drug-name">{{
                            item.item_drug_name
                          }}</span>
                          <div class="badges-container">
                            <b-badge variant="secondary">
                              {{ item.dose }}
                            </b-badge>
                            <b-badge variant="light-primary">
                              {{ item.number_of_doses }} doses
                            </b-badge>
                            <b-badge variant="light-warning">
                              Every {{ item.duration_between_doses }}
                            </b-badge>
                            <b-badge variant="light-success">
                              {{ item.type }}
                            </b-badge>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template #cell(actions)="data">
                <div class="text-nowrap d-flex">
                  <b-button
                    size="sm"
                    pill
                    variant="outline-secondary"
                    class="mb-75 mx-1"
                    @click="
                      $router.push({
                        name: 'patient-drug-table-id',
                        params: { id: data.item.id },
                      })
                    "
                  >
                    {{ $t("emergency.show-drug-table") }}
                  </b-button>
                </div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getPatientCards()"
          >
            <b-pagination
              v-model="page"
              :total-rows="dataCount"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  BFormInput,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BIconSearch,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import PatientSearch from "@/components/patientSearch.vue";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BIconSearch,
    PatientSearch,
  },
  data() {
    return {
      tableColumns: [
        { key: "patient.name", label: this.$t("common.name"), sortable: true },
        {
          key: "patient_card_prescriptions",
          label: this.$t("emergency.drugs-prescription"),
          sortable: true,
        },
        {
          key: "type",
          label: this.$t("reception.card-type"),
          sortable: true,
        },

        {
          key: "patient.birth_date",
          label: this.$t("reception.birth-date"),
          sortable: true,
        },
        {
          key: "patient.phone",
          label: this.$t("reception.phone"),
          sortable: true,
          class: "text-nowrap",
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      patientCardsData: [],

      page: 1,
      totalRows: "",
      todayDate: "",
      take: 10,
      loading: false,
      selected: "",
      option: [],
      allItems: [],
      dataCount: 0,
      patientName: "",
    };
  },

  mounted() {
    this.getPatientCards();
  },
  methods: {
    getPatientPhone(data) {
      return `${data.item.patient?.phone || ""}`;
    },
    // this is trmporary

    async getPatientCards() {
      this.loading = true;
      let url = `/patientCard?include[]=patient&page=${this.page}&take=${this.take}&sort=-id&filter[is_active]=1&include[]=patientCardPrescriptions&include[]=patientCardDrugTable`;

      if (this.patientName) {
        url += `&filter[patient.name]=${this.patientName}`;
      }

      await this.getList(url);
      for (const item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.dataCount = this.all_data.total;
      this.patientCardsData = this.all_data.data;
      await this.getAllItems();
      this.patientCardsData.forEach((item) => {
        const prescriptions = item.patient_card_prescriptions || [];
        prescriptions.forEach((prescription) => {
          if (prescription.item_id && Array.isArray(this.allItems)) {
            const matchedItem = this.allItems.find(
              (allItem) => allItem && allItem.id === prescription.item_id
            );
            prescription.item_drug_name = matchedItem
              ? matchedItem.name
              : prescription.item_name || "";
          } else {
            prescription.item_drug_name = prescription.item_name || "";
          }
        });
        item.patient_card_prescriptions = prescriptions;
      });
      this.loading = false;
    },
    async getAllItems() {
      const url = "/item?take=2000";
      await this.getList(url);
      this.allItems =
        this.all_data && Array.isArray(this.all_data.data)
          ? this.all_data.data
          : [];
      console.log(this.allItems, "allItems");
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

#modal-add___BV_modal_content_ {
  width: 100% !important;
}

#modal-add {
  margin-left: -8% !important;
}

.prescription-grid {
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: center;
  // gap: 0.1rem;
}

.drug-name {
  font-size: 15px;
  font-weight: 900;
}

.badges-container {
  display: flex;
  gap: 1rem;
  align-items: center;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
